import Angular from "angular";
import Controller from "./branch-selection.controller";
import Template from "./branch-selection.html";
import Settings from "../../providers/settings.provider";
import Branches from "../../services/branches.service";

export const BranchSelectionView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.branch-selection', [Settings.name, Branches.name]);



// WEBPACK FOOTER //
// ./src/modules/main/views/branch-selection/branch-selection.js